// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1BE86","addWidgetButton":"Header_addWidgetButton__3Xxdp","dashboardTabs":"Header_dashboardTabs__1kjmF","active":"Header_active__12fRX"};